// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallRequiredDateType {
    Approximative = "A",
    Fixed = "F",
    Limited = "L",
}

export let nameof = "ServiceCallRequiredDateType";
